import React, { useMemo } from "react";
import ViewOrder from "./ViewOrder";
import useDefaultCurrency from "../../utility/useDefaultCurrency";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function OrdersTableBody({ ordersData }) {
  const { data } = useDefaultCurrency("admin");
  const currency = useMemo(() => data?.currency?.symbol, [data]);

  function statusFormat(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const formatDateTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString(undefined, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  return (
    <tbody>
      {ordersData?.map((item) => (
        <tr
          key={item?.id}
          className="hover:bg-gray-100 border-b border-gray-300"
        >
          <td className="py-2 px-4 text-wrap">{item?.orderNO}</td>
          <td className="py-2 px-4 text-center">{item?.customer?.name}</td>
          <td className="py-2 px-4 text-center">
            {item?.user?.firstname} {item?.user?.lastname}
          </td>
          <td className="py-2 px-4 text-center">{item?.payment_type}</td>
          <td className="py-2 px-4 text-center">
            {currency}
            {formatNumbersWithDecimal(item?.total_price)}
          </td>
          <td className="py-2 px-4 text-center">
            {formatDateTime(item?.created_at)}
          </td>
          <td className="py-2 px-4 text-center">
            <div
              className={`p-1 text-white rounded-md ${
                item?.status === "COMPLETED" ? "bg-green-500" : "bg-yellow-500"
              }`}
            >
              {statusFormat(item?.status)}
            </div>
          </td>
          <ViewOrder item={item} currency={currency} />
        </tr>
      ))}
    </tbody>
  );
}

export default React.memo(OrdersTableBody);
